import * as React from "react";
const SvgInfoOrange = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={17}
    fill="none"
    {...props}
  >
    <rect width={13} height={13} x={0.5} y={2} stroke="#FF8503" rx={6.5} />
    <path
      stroke="#FF8503"
      strokeLinejoin="round"
      strokeWidth={1.15}
      d="m7 5.583.003 4.084"
    />
    <path
      stroke="#FF8503"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.15}
      d="M6.996 11.417h.008"
    />
  </svg>
);
export default SvgInfoOrange;
